export const languageElements = {
    items: {
      "field-ID": {
        hu: "#",
        de: "#",
        en: "#",
      },
  
      "field-DocType": {
        hu: "Dokumentum típusa",
        de: "Dokument Typ",
        en: "Document Type",
      },
  
      "field-Barcode01": {
        hu: "Azonosító",
        de: "Dokument ID",
        en: "Document ID",
      },
  
      "field-fileName": {
        hu: "Fájlnév",
        de: "Dateiname",
        en: "Filename",
      },
  
      "field-Description": {
        hu: "Leírás",
        de: "Beschreibung",
        en: "Description",
      },
  
      "field-PosNum": {
        hu: "Pozíciószám",
        de: "Send.Nr",
        en: "Pos.Nr",
      },
  
      "field-InvNum": {
        hu: "Számlaszám",
        de: "Rechnungsnummer",
        en: "Invoice number",
      },
  
      "field-PO_Num": {
        hu: "Megrendelésszám",
        de: "Bestellnummer",
        en: "PO number",
      },
  
      "modal-button-download": {
        hu: "Kijelöltek letöltése",
        de: "Download ausgewählt",
        en: "Download selected",
      },
  
      "alert-no-document-selected": {
        hu: "Nem választott ki egyetlen dokumentumot sem.",
        de: "Kein Dokument ausgewählt",
        en: "No document selected",
      },
    },
  };
  